module.exports = __webpack_public_path__ + "media/images/svg/realestate/balcony-e818785fcc48bb36d14e28b41c5263c6.svg";